.moving-header {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &__container {
    padding: $space-04 $space-03;
    align-items: center;
    width: 100%;
    display: inline-block;

    @include agl-ds-screen-size('medium') {
      font-family: $font-family-02;
      padding: $space-06 0;
      align-items: start;
      display: flex;
      width: 100%;
      flex-direction: column;
    }
  }

  &__selection {
    display: inline-block;
    gap: $space-01;
    width: 100%;
    font-weight: $font-weight-semi-bold;
    padding: 0;
    text-align: center;

    @include agl-ds-screen-size('medium') {
      text-align: left;
      flex-wrap: wrap;
      display: flex;
    }

    &__message {
      color: $neutral-01;
      font: $font-weight-semi-bold $font-size-lg-06 $font-family-01;

      @include agl-ds-screen-size('medium') {
        flex-grow: 1;
        flex-basis: auto;
        font-size: $font-size-md-07;
      }
    }

    &__continue {
      display: flex;
      flex-direction: column;
      font-size: $font-size-md-01;
      text-align: center;
      line-height: 140%;
      justify-content: center;
      margin-top: $space-03;

      @include agl-ds-screen-size('medium') {
        margin-top: 0;
      }

      &__container {
        border-radius: $space-08;
        gap: $space-01;
        padding: $space-01 0 $space-01 $space-02;
      }

      &__message {
        font-family: $font-family-02;
        flex-grow: 1;
        margin: auto 0;

        a {
          text-decoration: none !important;
        }
      }
    }
  }

  &__address {
    align-self: stretch;
    font-family: $font-family-02;
    border-radius: $space-01;
    background-color: $neutral-08;
    display: flex;
    margin-top: $space-03;
    flex-direction: column;
    font-size: $font-size-sm-04;
    justify-content: center;
    padding: 12px $space-02;
    gap: $space-02;

    @include agl-ds-screen-size('medium') {
      padding: 0 $space-04;
    }

    &__container {
      justify-content: center;
      display: flex;
      flex-direction: column;
      padding: 12px $space-02;

      @include agl-ds-screen-size('medium') {
        padding: $space-03 0;
      }
    }

    &__plan-available {
      font: $font-weight-semi-bold $font-size-sm-04 $font-family-02;
      line-height: 140%;
    }

    &__info {
      font: $font-weight-regular $font-size-lg-01 $font-family-02;
      color: $neutral-01;
      margin-top: 8px;

      @include agl-ds-screen-size('medium') {
        font: $font-weight-regular $font-size-md-03 $font-family-02;
      }
    }
  }
}
